import { useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { TrainingRequestWizard } from 'modules/benefits/components/TrainingRequestWizard'
import { SupportedBenefitId } from 'modules/benefits/lib/benefitListings'

export const RequestBenefitsForm = () => {
  const { benefitId } = useParams<{ benefitId: SupportedBenefitId }>()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const handleClose = useCallback(() => {
    navigate(navigation.myBenefits.benefits.fullPath())
  }, [navigate, navigation])

  const wizard = useMemo(() => {
    switch (benefitId) {
      case 'trainings_es':
        return <TrainingRequestWizard onClose={handleClose} />
      default:
        return null
    }
  }, [benefitId, handleClose])

  useUnsafeEffect(() => {
    // If no wizard is resolved for the benefitId, redirect to benefits list
    if (!wizard) {
      navigate(navigation.myBenefits.benefits.fullPath())
    }
  }, [wizard, navigation, navigate])

  return wizard
}
